module.exports = __webpack_public_path__ + "static/media/blue-white-measure-tape-long.5d149b1a.png";